import * as React from "react";
const SvgFiRrMonument = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-monument_svg__a)">
      <path
        fill="#062147"
        d="M24 23a1 1 0 0 1-1 1H1a1 1 0 0 1 0-2h22a1 1 0 0 1 1 1M2 19a1 1 0 0 1 1-1h2.065L6.559 5.306a5.03 5.03 0 0 1 1.43-2.952l1.183-1.182c1.511-1.512 4.146-1.512 5.656 0l1.183 1.182a5.02 5.02 0 0 1 1.43 2.952L18.935 18H21a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1m14.921-1L15.627 7h-2.626v11h3.921zM8.661 5h6.678a3 3 0 0 0-.742-1.232l-1.183-1.182c-.756-.756-2.072-.756-2.828 0L9.403 3.768c-.344.344-.598.77-.742 1.232M7.079 18H11V7H8.374z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-monument_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMonument;
